// tslint:disable
/**
 * Projecto API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 10.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TeamFromJSON(json) {
    return {
        'fmRecordID': !exists(json, 'fmRecordID') ? undefined : json['fmRecordID'],
        'fmModID': !exists(json, 'fmModID') ? undefined : json['fmModID'],
        'projectTeamID': !exists(json, 'projectTeamID') ? undefined : json['projectTeamID'],
        'projectID': !exists(json, 'projectID') ? undefined : json['projectID'],
        'contactID': !exists(json, 'contactID') ? undefined : json['contactID'],
        'role': !exists(json, 'role') ? undefined : json['role'],
        'addPjtAccess': !exists(json, 'addPjtAccess') ? undefined : json['addPjtAccess'],
        'teamMemberNotes': !exists(json, 'teamMemberNotes') ? undefined : json['teamMemberNotes'],
        'portalSorter': !exists(json, 'portalSorter') ? undefined : json['portalSorter'],
        'createdDate': !exists(json, 'createdDate') ? undefined : new Date(json['createdDate']),
        'createdTime': !exists(json, 'createdTime') ? undefined : new Date(json['createdTime']),
        'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
        'modifiedDate': !exists(json, 'modifiedDate') ? undefined : new Date(json['modifiedDate']),
        'modifiedTime': !exists(json, 'modifiedTime') ? undefined : new Date(json['modifiedTime']),
        'modifiedBy': !exists(json, 'modifiedBy') ? undefined : json['modifiedBy'],
    };
}
export function TeamToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'fmRecordID': value.fmRecordID,
        'fmModID': value.fmModID,
        'projectTeamID': value.projectTeamID,
        'projectID': value.projectID,
        'contactID': value.contactID,
        'role': value.role,
        'addPjtAccess': value.addPjtAccess,
        'teamMemberNotes': value.teamMemberNotes,
        'portalSorter': value.portalSorter,
        'createdDate': value.createdDate === undefined ? undefined : value.createdDate.toISOString(),
        'createdTime': value.createdTime === undefined ? undefined : value.createdTime.toISOString(),
        'createdBy': value.createdBy,
        'modifiedDate': value.modifiedDate === undefined ? undefined : value.modifiedDate.toISOString(),
        'modifiedTime': value.modifiedTime === undefined ? undefined : value.modifiedTime.toISOString(),
        'modifiedBy': value.modifiedBy,
    };
}
